module.exports = __webpack_public_path__ + "static/img/car-03.5930498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/car-03.jpg
// module id = r/Qz
// module chunks = 0